import React from 'react';
import { Wrench, Phone, Mail, MapPin } from 'lucide-react';
import { LOGO_URL, COMPANY } from '../mock';

// Friendly "be right back" maintenance page shown to customers when
// the owner has temporarily un-published the public site from Admin → Settings.
export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden flex items-center justify-center p-6">
      {/* subtle red radial */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(60% 60% at 50% 30%, rgba(225,29,44,0.18) 0%, transparent 70%)' }} />
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#e11d2c]/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#e11d2c]/10 blur-3xl" />

      <div className="relative z-10 max-w-2xl w-full text-center" data-testid="maintenance-page">
        <img src={LOGO_URL} alt="Timeless Auto Imports" className="w-28 h-28 object-contain mx-auto mb-6 drop-shadow-2xl" />

        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 backdrop-blur-md rounded-full px-4 py-1.5 text-[11px] tracking-[0.22em] uppercase font-semibold text-white/85 mb-6">
          <Wrench size={13} className="text-[#e11d2c]" />
          Site update in progress
        </div>

        <h1 className="font-display text-[44px] sm:text-[58px] font-black leading-[1.05] tracking-tight mb-4">
          We&apos;ll be <span className="text-[#e11d2c]">back soon</span>.
        </h1>
        <p className="text-white/70 text-base sm:text-lg max-w-md mx-auto mb-10">
          Our website is currently being updated with fresh inventory. In the meantime, reach out to us directly — we&apos;re always open to talk cars.
        </p>

        <div className="grid sm:grid-cols-3 gap-3 max-w-xl mx-auto mb-10">
          <a href={`tel:${COMPANY.phone1}`} className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#e11d2c]/60 rounded-2xl p-4 transition-all">
            <Phone size={18} className="text-[#e11d2c] mx-auto mb-2" />
            <div className="text-[10px] tracking-[0.22em] uppercase text-white/55 font-semibold">Call</div>
            <div className="text-sm font-semibold mt-1">{COMPANY.phone1}</div>
          </a>
          <a href={`mailto:${COMPANY.email}`} className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#e11d2c]/60 rounded-2xl p-4 transition-all">
            <Mail size={18} className="text-[#e11d2c] mx-auto mb-2" />
            <div className="text-[10px] tracking-[0.22em] uppercase text-white/55 font-semibold">Email</div>
            <div className="text-xs font-semibold mt-1 break-all">{COMPANY.email}</div>
          </a>
          <div className="bg-white/5 border border-white/10 rounded-2xl p-4">
            <MapPin size={18} className="text-[#e11d2c] mx-auto mb-2" />
            <div className="text-[10px] tracking-[0.22em] uppercase text-white/55 font-semibold">Visit</div>
            <div className="text-xs font-semibold mt-1 leading-tight">Lot 36, Bustamante Hwy<br/>Four Path, Clarendon</div>
          </div>
        </div>

        <div className="text-[11px] tracking-[0.22em] uppercase text-white/40">
          Timeless Auto Imports Limited · Don&apos;t Just Dream It, Drive It
        </div>
      </div>
    </div>
  );
}
